import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Pagination} from "react-bootstrap";
import './projectSlider.scss';
import { useAnimationContext } from '../../AnimationContext';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const images = [
    {
        url: './img/Peanuts.png',
        service: 'Branding',
        title: 'Consectetuer Adipiscing',
        description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit',
    },
    {
        url: './img/ahph.png',
        service: 'Web Design',
        title: 'Africa Herald \n Publishing House',
        description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed Lorem ipsum dolor sit amet,&nbsp;erat volutpat. Ut wisi enim ad minidiam nonummy nibh euismod tincidunt ut laoreet dolore mat. Ut wisi enim ad minim Lorem ipsum dolor',
    },
    {
        url: './img/SixtySeven.png',
        service: 'Branding',
        title: 'Sixty Seven \n Cafe',
        description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed Lorem ipsum dolor sit amet, erat volutpat. Ut wisi enim ad minidiam nonummy nibh euismod tincidunt ut laoreet dolore mat. Ut wisi enim ad minim Lorem ipsum dolor',
    },
    {
        url: './img/Print.png',
        service: 'Print Graphics',
        title: 'Finding \n Contentment',
        description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit',
    },
    {
        url: './img/Vernie.png',
        service: 'Illustrations',
        title: 'Lorem Ipsum',
        description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed Lorem ipsum dolor sit amet,&nbsp;erat volutpat. Ut wisi enim ad minidiam nonummy nibh euismod tincidunt ut laoreet dolore mat. Ut wisi enim ad minim Lorem ipsum dolor',
    },
];

const ProjectsSlider = () => {
    const { isPreloaderComplete } = useAnimationContext();
    const [currentIndex, setCurrentIndex] = useState(2);
    const currentImage = images[currentIndex];
    const sliderImagesRef = useRef(null);
    const serviceRef = useRef(null);
    const titleRef = useRef(null);
    const descriptionRef = useRef(null);

    const handleSelect = (newIndex) => {
        const currentElement = sliderImagesRef.current; // Current image element
        const currentImageOutTL = gsap.timeline(); // Create a timeline for the current image to slide out
    
        currentImageOutTL
        .to(currentElement, {
            x: '-90%',
            opacity: 0,
            duration: 1,
            ease: "power1.in",
            onComplete: () => {
                setCurrentIndex(newIndex);
                gsap.set(currentElement, { x: '90%' });
                gsap.to(currentElement, {
                    x: '0%',
                    opacity: 1,
                    duration: 1,
                    ease: "power1.out",
                    onComplete: () => {
                        // Animate text elements in after image slides in
                        gsap.fromTo([serviceRef.current, titleRef.current, descriptionRef.current], 
                            { opacity: 0, y: 20 },
                            { opacity: 1, y: 0, duration: 0.5, ease: "power1.out", stagger: 0.1 }
                        );
                    }
                });
                // Animate text elements out after image slides out
                gsap.to([serviceRef.current, titleRef.current, descriptionRef.current], {
                    opacity: 0,
                    y: -20,
                    duration: 0.5,
                    ease: "power1.out",
                });
            },
        });
    };

    //header highlighter on scroll
    useEffect(() => {
        if (isPreloaderComplete) {
            gsap.utils.toArray('.headerTextProjects').forEach(headerText => {
                gsap.to(headerText, {
                    scrollTrigger: {
                        trigger: headerText,
                        start: 'top 95%',
                        //end: 'bottom center',
                        //toggleActions: 'play none none reverse', // Play the animation forward when entering and reverse when leaving
                        onEnter: () => headerText.classList.add('highlight-heading'),
                        //onLeaveBack: () => header.classList.remove('highlight-heading'),
                    }
                });
            });
            
        }
    }, [currentIndex, isPreloaderComplete]);

  return (
<Container fluid id="secProjects">
    <Row>
        <Col xs={12} md={6} className="d-flex flex-column justify-content-around justify-content-md-between" id="sliderInfoCol">
            <div className="d-flex flex-column align-items-start" style={{marginBottom:"1.5rem"}} >
                <h1 className="headerTextProjects">Select</h1>
                <h1 className="headerTextProjects">Projects</h1>
            </div>
            <div className="d-flex justify-content-center align-items-center justify-content-md-start">
                <h1 id="h1Pagination">{(currentIndex + 1).toString().padStart(2, '0')}</h1>
                <div style={{zIndex: 10}}>
                <h5 ref={serviceRef}>{currentImage.service}</h5>
                <h3 ref={titleRef}>{currentImage.title.split('\n').map((line, index, array) => (
                            <React.Fragment key={index}>
                                {line}
                                {index < array.length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </h3>
                </div>
            </div>
            <div className="d-none d-md-flex justify-content-start align-items-start">
                <p ref={descriptionRef}>{currentImage.description}</p>
            </div>
        </Col>
        <Col xs={12} md={6} className="d-flex justify-content-center justify-content-md-start align-items-center" id="sliderImagesCol">
            <div id="sliderImagesBg"></div>
            <div id="sliderImages" ref={sliderImagesRef}><img src={currentImage.url} alt={currentImage.title} /></div>
        </Col>
        <Col xs={12} md={12} className="paginatorCol">
            <p className="d-md-none">{currentImage.description}</p>
                    
            <nav className="d-flex justify-content-center align-items-center justify-content-md-start">
                <Pagination>
                <Pagination.Prev className="sliderArrow prev" 
                    onClick={() => handleSelect(currentIndex === 0 ? images.length - 1 : currentIndex - 1)} />
                {images.map((_, index) => (
                    <Pagination.Item key={index} active={index === currentIndex} onClick={() => handleSelect(index)} >
                        {index + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next className="sliderArrow next"
                    onClick={() => handleSelect((currentIndex + 1) % images.length)} />
                </Pagination>
            </nav>
        </Col>
    </Row>
</Container>
  );
};

export default ProjectsSlider;
